import { plainToClass } from 'class-transformer'
import { formatFileSize, secureFileLink } from '../../functions'
import { epochToView } from '../../functions'
import { Expose, Serializable } from '../../functions/serializer'

export class Attachment extends Serializable<Attachment> {
  @Expose({ name: 'pkey' })
  id: string

  account: number
  archived: number
  basename: string
  created: number
  location: string
  name: string
  size: number
  type: string
  url: string
  user: string
  path: string
  uri: string
  created_by?: string

  contract: number // is contract or not
  service: string // dropbox, s3

  createdView: string
  sizeView: string
  isImage: boolean
  isVendorImage: boolean

  static deserialize(data: any): Attachment {
    let attachment: Attachment = plainToClass<Attachment, Attachment>(Attachment, data)

    attachment.createdView = epochToView(attachment.created)
    attachment.sizeView = formatFileSize(attachment.size)
    attachment.isImage = attachment.type?.startsWith('image/')
    attachment.isVendorImage = attachment?.created_by?.startsWith('vendor')

    return attachment
  }
}

export function getAttachmentLinks(attachments: Attachment[], guestId?: string, plainText = false) {
  if (!attachments?.length) {
    return ''
  }

  if (plainText) {
    return attachments
      .map((file: Attachment) => `[[${file.name}]] \n ${secureFileLink(file.url, guestId)}`)
      .join('\n\n')
  }

  const content = attachments
    .map(
      (file: Attachment) =>
        `<a href="${secureFileLink(file.url, guestId)}" target="_blank" id="${file.id}" class="attachment">${
          file.name
        }</a>`
    )
    .join('<br>')

  return `<div class="attachments">${content}</div>`
}
